<template>
  <div class="wrapper">
    <layout-default></layout-default>
  </div>
</template>
<script>
import LayoutDefault from '@/layouts/LayoutDefault'
export default {
  components: {
    LayoutDefault
  }
}
</script>
